<template>
  <div class="page-home container">
    <el-button
      type="success"
      icon="el-icon-plus"
      class="mb-3 mt-5"
      @click="dialogVisible = true"
    >
      افزودن
    </el-button>
    <data-table
      ref="table"
      class="mt-3"
      title="لیست کاربران"
      uid="table-devices"
      :query="query"
      :options="options"
      :on-edit="
        item => {
          editing = item.id
          dialogVisible = true
        }
      "
    >
      <el-table-column
        prop="name"
        label="نام"
        align="center"
        min-width="100"
        sortable="custom"
      />
      <el-table-column
        prop="mobile"
        label="موبایل"
        align="center"
        min-width="100"
      />
      <el-table-column prop="role" label="نقش" align="center" min-width="100">
        <el-tag
          slot-scope="{ row }"
          :type="
            $options.filters.roleData(row.role).title === 'مدیر' ? '' : 'info'
          "
          >{{ $options.filters.roleData(row.role).title }}</el-tag
        >
      </el-table-column>

      <el-table-column
        prop="devices"
        label="دستگاه ها"
        align="center"
        min-width="70"
        sortable="custom"
      >
        <el-button
          slot-scope="{ row }"
          :disabled="!row.devices"
          type="info"
          size="mini"
          plain
          class="font-11 rounded-md"
          @click="goToDevices(row.id, row.name)"
        >
          <i class="ic-router font-12 ml-2"></i>
          {{ row.devices ? row.devices.length : 0 }}
        </el-button>
      </el-table-column>
      <el-table-column
        prop="credit"
        label="موجودی حساب"
        align="center"
        min-width="100"
        ><div v-number slot-scope="{ row }">
          {{ row.credit / 10 }} تومان
        </div></el-table-column
      >
      <el-table-column prop="id" align="center" min-width="100">
        <a slot-scope="{ row }" @click="handleLoginAs(row.id)">
          <el-button type="primary">
            ورود
          </el-button>
        </a>
      </el-table-column>
    </data-table>
    <user-form
      :show.sync="dialogVisible"
      :editing-id.sync="editing"
      @updateTable="update"
    />
  </div>
</template>

<script>
import ListQuery from '@/graphql/user/Users.gql'
import UserForm from '@/views/User/Form'
export default {
  name: 'UsersList',
  components: {
    UserForm
  },
  data() {
    return {
      loading: false,
      query: ListQuery,
      dialogVisible: false,
      editing: null
    }
  },
  computed: {
    options() {
      let filters = [
        {
          type: 'input',
          field: 'name',
          attr: {
            type: 'text',
            placeholder: 'جستجو در نام'
          }
        },
        {
          type: 'input',
          field: 'mobile',
          attr: {
            type: 'text',
            placeholder: 'جستجو در موبایل'
          }
        }
      ]
      return {
        filters,
        columns: []
      }
    }
  },
  methods: {
    handleLoginAs(userId) {
      let cookie = `${this.$settings.get('token')}/*/${userId}`
      this.$settings.setCookie('LOGIN_AS', cookie, process.env.VUE_APP_DOMAIN)
      window.open(process.env.VUE_APP_PANEL, '_blank')
    },
    update() {
      this.$refs.table.update()
    },
    goToDevices(userId, userName) {
      this.$router.push({ name: 'devices', params: { userId, userName } })
    }
  }
}
</script>
